import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs/RX';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { ISelectItem } from '../models/select-item';
import { AuthenticationService } from './authentication.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DropDownsService {
    constructor(
        private http: HttpClient, 
        private authService: AuthenticationService) { }

    private apiUrl = environment.api_url + 'DropDowns/';
    private getHttpOptions() {
        return this.authService.getAuthHttpOptions();
    }

    getAgencies(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetAgencies', this.getHttpOptions());
    }

    getCenters(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetCenters', this.getHttpOptions());
    }

    getCameraTours(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetCameraTours', this.getHttpOptions());
    }

    getCounties(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetCounties', this.getHttpOptions());
    }

    getHighways(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetHighways', this.getHttpOptions());
    }

    getLocations(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetLocations', this.getHttpOptions());
    }

    getRoles(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetRoles', this.getHttpOptions());
    }

    getUsers(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetUsers', this.getHttpOptions());
    }

    getUserGroups(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetUserGroups', this.getHttpOptions());
    }

    getWowzaChannels(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetWowzaChannels', this.getHttpOptions());
    }

    getWowzaServers(): Observable<ISelectItem[]> {
        return this.http.get<ISelectItem[]>(this.apiUrl + 'GetWowzaServers', this.getHttpOptions());
    }
}
